var cilDrinkAlcohol = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M248,440H176v32H352V440H280V318.968L456,126.206V80H72v46.206L248,318.968ZM104,113.794V112H424v1.794L374.508,168H153.492ZM182.709,200H345.291l-80.349,88h-1.884Z' class='ci-primary'/>"];

export { cilDrinkAlcohol };

